import React, { useState } from "react";
import ResetPasswordFormView, { 
  SuccessView, 
  LoadingView, 
  ErrorView, 
  ExpiredView, 
  NotFoundView 
} from "./ResetPasswordFormView";
import { useMutation } from "@tanstack/react-query";
import { resetPasswordAPI } from "../../services/user.api";
import useQueryURL from "../../../../utils/useQueryURL";
import useSingleResetPasswordRequest from "../../hook/userResetPasswordRequest";

export default function ResetPasswordForm() {
  const { getQueryValue } = useQueryURL();
  const requestId = getQueryValue("requestId");
  const [error, setError] = useState<string | null>(null);
  const [isDone, setIsDone] = useState(false);
  const { singleResetPasswordRequestQuery } = useSingleResetPasswordRequest(requestId || undefined);



  const { mutate, isPending } = useMutation({
    mutationFn: ({
      requestId,
      newPassword,
    }: {
      requestId: string;
      newPassword: string;
    }) => resetPasswordAPI(requestId, newPassword),
    onSuccess: () => {
      setError(null);
      setIsDone(true);
    },
    onError: (error) => {
      setError("Erreur lors de la réinitialisation du mot de passe");
    },
  });

  const handleSubmit = (newPassword: string) => {
    if (!requestId) {
      setError("ID de réinitialisation de mot de passe non trouvé");
      return;
    }
    mutate({ requestId, newPassword });
  };

  if (singleResetPasswordRequestQuery.isLoading) {
    return <LoadingView />;
  }

  if (singleResetPasswordRequestQuery.isError) {
    return <ErrorView />;
  }

  if (singleResetPasswordRequestQuery.data?.rpr_status !== "PENDING") {
    return <ExpiredView />;
  }

  if (isDone) {
    return <SuccessView />;
  }

  if (!requestId || requestId === "undefined" || requestId === "null") {
    return <NotFoundView />;
  }

  return (
    <>
      <ResetPasswordFormView
        handleSubmit={handleSubmit}
        error={error}
        isLoading={isPending}
      />
    </>
  );
}
